<template>
  <div id="login">
    <Spinner v-if="isLoading"/>
    <form>
      <h1>Σύνδεση στο σύστημα</h1>
      <span v-if="errorMsg">{{ errorMsg }}</span>

      <input id="username" type="username" v-model="username" required placeholder="Username" autofocus>
      <input id="password" type="password" v-model="password" placeholder="Κωδικός" required>

      <button type="submit" class="sav-btn sav-btn-red full-width" @click="handleSubmit">
        Σύνδεση
      </button>
      <!-- <router-link to="/register" class="sav-btn sav-btn-link full-width align-center">Εγγραφή</router-link> -->
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import Spinner from './Spinner.vue'

export default {
  components: {
    Spinner
  },
  data(){
    return {
      apiUrl: this.$parent.apiUrl,
      isLoading: false,
      username : "",
      password : "",
      errorMsg: ""
    }
  },
  methods : {
    handleSubmit(e){
      e.preventDefault();
      
      if (this.username == "" || this.password.length == 0) {
        this.errorMsg = "Συμπληρώστε όλα τα πεδία"
      } else {
        this.errorMsg = "";
        this.login();
      }
    },
    login() {
      let url = this.apiUrl + '/login';
      let formData = {
        username: this.username,
        password: this.password
      }
      let headers = { 
        headers: {
        'Content-type': 'application/json',
        }
      };

      axios.post(url, formData, headers)
        .then(response => {
          this.isLoading = false;
          localStorage.setItem('sav-erp-user', JSON.stringify(response.data.user));
          this.$cookie.set('sav-erp-token', response.data.token, { expires: '15m' });
          this.$cookie.set('sav-erp-refresh-token', response.data.refreshToken, { expires: '8h' });

          if (this.$cookie.get('sav-erp-token') != null){
              this.$emit('loggedIn')
              if (this.$route.params.nextUrl != null){
                this.$router.push(this.$route.params.nextUrl)
              } else {
                this.$router.push('/')
              }
          }
        })
        .catch(error => {
          let response = error.response;

          if (!response) {
            this.errorMsg = "Μη ενεργός server";
          } else {
            this.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
          }
        });
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss">
@import "./../scss/_colors";

html, body, #app, #login {
  height: 100%;
}

#login {
  background-image: linear-gradient($blue, $blue 40%, white 40%, white);
  display: flex;
  justify-content: center;
  padding-top: 100px;
  align-items: flex-start;

  form {
    width: 500px;
    padding: 50px;
    background-color: white;
    box-shadow: 0 2px 9px rgba(0,0,0,.25);
    display: flex;
    flex-direction: column;

    h1 {
      margin-top: 0;
      margin-bottom: 40px;
      font-weight: normal;
    }

    span {
      margin-bottom: 20px;
      color: $red;
      font-weight: bold;
    }

    input {
      border: none;
      border-bottom: 2px solid $blue;
      margin-bottom: 30px;
      padding: 0;
      box-shadow: none;

      &::placeholder {
        color: $blue;
      }
    }

    button {
      margin-bottom: 20px;
    }
  }
}
</style>
